import React, { useState, useEffect } from "react";
import { FaHome } from "react-icons/fa";
import { FaFileInvoiceDollar } from "react-icons/fa";
import { RiMenuSearchFill } from "react-icons/ri";
import { HiMiniDocumentCurrencyRupee } from "react-icons/hi2";
import { useLayoutUpdate } from "../default/LayoutProvider";
import { useLocation, useNavigate } from "react-router-dom";
import { useRef } from "react";
export default function AdminFooter() {
  const location = useLocation();
  const naviagte = useNavigate();
  const layoutUpdate = useLayoutUpdate();
  const [visible, setVisible] = useState(true);
  const lastScrollY = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > lastScrollY.current) {
        setVisible(false);
      } else {
        setVisible(true);
      }
      lastScrollY.current = window.scrollY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navItems = [
    {
      key: "home",
      label: "Home",
      icon: FaHome,
      onClick: () => naviagte("/dashboard"),
      path: "/dashboard",
    },
    {
      key: "bill",
      label: "Bills",
      icon: FaFileInvoiceDollar,
      onClick: () => naviagte("/bill"),
      path: "/bill",
    },
    {
      key: "expense",
      label: "Expenses",
      icon: HiMiniDocumentCurrencyRupee,
      onClick: () => naviagte("/expense"),
      path: "/expense",
    },
    {
      key: "cashflow",
      label: "CashFlow",
      icon: RiMenuSearchFill,
      onClick:() => naviagte("/cashflow"),
      path: "/cashflow",
    },
  ];
  return (
    <div
      className="position-fixed bottom-0 mb-1 w-100 d-flex justify-content-center transition-all"
      style={{
        zIndex: 1000,
        transform: visible ? "translateY(0)" : "translateY(100%)",
        opacity: visible ? 1 : 0,
        pointerEvents: visible ? "auto" : "none",
        transition: "transform 0.3s ease, opacity 0.3s ease",
      }}
    >
      <div
        className="position-relative shadow py-1 rounded-3 d-flex justify-content-between align-items-center"
        style={{ backgroundColor: "rgb(20,20,20,0.95)", width: "95%" }}
      >
        {navItems.map(({ key, label, icon: Icon, onClick,path }) => (
          <div
            key={key}
            className="text-center flex-fill"
            onClick={() => {
              onClick();
            }}
            style={{ cursor: "pointer" }}
          >
            <Icon
              size={20}
              color={
                location.pathname === path
                  ? "#e40e0e"
                  : "white"
              }
            />
            <div
              style={{
                fontSize: "0.6rem",
                color:
                  location.pathname === path
                    ? "#e40e0e"
                    : "white",
              }}
            >
              {label}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
